export { default } from './IntegrationModal.vue'
